import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
// import { selectPartData } from 'Core/redux/part/selectors';
import { selectCustomerData } from 'Core/redux/customer/selectors';
import { selectLocations } from 'Core/redux/location/selectors';
import { useTransformOptions } from 'Core/hooks';
import { TextEditor } from 'Core/components/editor';
import CustomPropTypes from 'CustomPropTypes';
import UploadImage from './partmasters-upload-image';
import { Button } from 'react-bootstrap';
// import { fetchStatuses } from '../../core/redux/status/slice';
// import { fetchLabels } from '../../core/redux/label/slice';
import { actions as partActions } from './store/slice';
import { Upload } from 'react-feather';
import UploadDrawing from './upload-drawing';

const { setUploadDrawingVisible } = partActions;

const initData = {

  id: 0,
  userId: "",
  partNumber: "",
  drawingNumber: "",
  drawingFile: "",
  partIdExt: "",
  customerId: "",
  customerIdExt: "",
  partsinaBox: "",
  partsonaPallet: "",
  boxWeight: "",
  palletWeight: "",
  boxDimensions: "",
  palletDimensions: "",
  description: "",
  // changed: "",
  // isDeleted: "",
  // confirmPickTicketScan: "",
  locationId: "",
  imageExtension: "",
  imageFile: ""

};

const PartAddEditForm = ({ data, onChanges, id }) => {
  const dispatch = useDispatch();
  const customers = useSelector(selectCustomerData);
  const locations = useSelector(selectLocations);
  const locationsOptions = useTransformOptions(locations, 'id', 'name', '', 'Select Location');
  const customersOptions = useTransformOptions(customers, 'id', 'customerName', '', 'Select Customer');

  const [formData, setFormData] = useState(data ? data : initData);

  const updateFormField = (fieldName, value) => {
    setFormData(prevData => ({
      ...prevData,
      [fieldName]: value,
    }));
    console.log({ ...formData, [fieldName]: value })
    onChanges({ ...formData, [fieldName]: value });
  };

  const imageFileChange = (fieldName, value) => {
    updateFormField(fieldName, value.filePath);
    updateFormField('imageExtension', value.extension);
  } 

  const expeditedList = [
    { value: 'No', label: 'No' },
    { value: 'Yes', label: 'Yes' },
  ];

  const openDrawingPopup = () => {
    dispatch(setUploadDrawingVisible(true));
  }

  return (
    <>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Image <span className="text-danger">*</span>
            </label>
            <UploadImage fileUrl={formData.imageFile} name={'imageFile'} onChanges={e => imageFileChange('imageFile', e)}/>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Upload Drawing <span className="text-danger">*</span>
            </label>
            <UploadDrawing fileUrl={formData.drawingFile} onClose={e => updateFormField('drawingFile', e.filePath)} onUploadSuccess={e => updateFormField('drawingFile', e.filePath)}/>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Part Number <span className="text-danger">*</span>
            </label>
            <input
              name="partNumber"
              type="text"
              className="form-control"
              value={formData.partNumber}
              onChange={e => updateFormField('partNumber', e.target.value)}
            />
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Description <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="description"
              value={formData.description}
              onChange={e => updateFormField('description', e.target.value)}
              className="form-control"
            />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Drawing Number <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="drawingNumber"
              value={formData.drawingNumber}
              onChange={e => updateFormField('drawingNumber', e.target.value)}
              className="form-control"
            />
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Customer <span className="text-danger">*</span>
            </label>
            <select
              value={formData.customerId}
              onChange={e => updateFormField('customerId', e.target.value)}
              className="form-control"
              required
            >
              {customersOptions.map(option => (
                <option key={option.label} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Parts in a box <span className="text-danger">*</span>
            </label>
            <input
              name="partsinaBox"
              type="text"
              className="form-control"
              value={formData.partsinaBox}
              onChange={e => updateFormField('partsinaBox', e.target.value)}
            />
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Parts on a pallet <span className="text-danger">*</span>
            </label>
            <input
              name="partsonaPallet"
              type="text"
              className="form-control"
              value={formData.partsonaPallet}
              onChange={e => updateFormField('partsonaPallet', e.target.value)}
            />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Box Weight <span className="text-danger">*</span>
            </label>
            <input
              name="boxWeight"
              type="text"
              className="form-control"
              value={formData.boxWeight}
              onChange={e => updateFormField('boxWeight', e.target.value)}
            />
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Pallet Weight <span className="text-danger">*</span>
            </label>
            <input
              name="palletWeight"
              type="text"
              className="form-control"
              value={formData.palletWeight}
              onChange={e => updateFormField('palletWeight', e.target.value)}
            />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Box Dimensions <span className="text-danger">*</span>
            </label>
            <input
              name="boxDimensions"
              type="text"
              className="form-control"
              value={formData.boxDimensions}
              onChange={e => updateFormField('boxDimensions', e.target.value)}
            />
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Pallet Dimensions <span className="text-danger">*</span>
            </label>
            <input
              name="palletDimensions"
              type="text"
              className="form-control"
              value={formData.palletDimensions}
              onChange={e => updateFormField('palletDimensions', e.target.value)}
            />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Location <span className="text-danger">*</span>
            </label>
            <select
              value={formData.locationId}
              onChange={e => updateFormField('locationId', e.target.value)}
              className="form-control"
              name="locationId"
              required
            >
              {locationsOptions.map(option => (
                <option key={option.label} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </>
  );
};

PartAddEditForm.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  data: PropTypes.shape(CustomPropTypes.part),
  onChanges: PropTypes.func,
};

export default PartAddEditForm;
